module.exports = __webpack_public_path__ + "static/media/benefits_texture.24cf5605.png";